import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Rain Cloud illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-rain-cloud',
    styleUrl: 'rain-cloud.css',
    shadow: true,
})
export class EsIllustrationRainCloud {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enable-background="new 0 0 582.5 786.3"
                viewBox="0 0 582.5 786.3"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <path
                    d="M124.2 385.5c-4.3-2.5-8.1-2.6-11-.9L40 427.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st0"
                />
                <linearGradient
                    id="rain_cloud_SVGID_1_"
                    x1="77.872"
                    x2="93.007"
                    y1="409.416"
                    y2="435.632"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#FFF" />
                    <stop offset="1" stop-color="#BBDEFB" />
                </linearGradient>
                <path
                    d="M124.2 385.5c-1.1-.7-2.2-1.1-3.3-1.5l-80.4 46.5 5.2 34.5 94-54c-1-9.9-7.6-20.9-15.5-25.5z"
                    class="rain_cloud_st1"
                />
                <path
                    d="M50.2 428.5c-8.7-5-15.8-.4-15.8 10.2V535c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V457c0-10.7-7.1-23.5-15.8-28.5z"
                    class="rain_cloud_st2"
                />
                <path
                    d="M64.5 497.5h2.2l.8-.5v-40c-.1-4.2-.9-8.4-2.6-12.3l-2.3.8-.5.2c1.5 3.6 2.3 7.4 2.4 11.3v40.5z"
                    class="rain_cloud_st3"
                />
                <path
                    d="M124.2 385.5h0c-4.3-2.5-8.1-2.6-11-.9h0L40 427.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st4"
                />
                <path
                    d="M218.2 478.5c-4.3-2.5-8.1-2.6-11-.9L134 520.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st0"
                />
                <linearGradient
                    id="rain_cloud_SVGID_00000098917404111798749890000006138884721509833146_"
                    x1="171.868"
                    x2="187.004"
                    y1="502.409"
                    y2="528.625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#FFF" />
                    <stop offset="1" stop-color="#BBDEFB" />
                </linearGradient>
                <path
                    fill="url(#rain_cloud_SVGID_00000098917404111798749890000006138884721509833146_)"
                    fill-rule="evenodd"
                    d="M218.2 478.5c-1.1-.7-2.2-1.1-3.3-1.5l-80.4 46.5 5.2 34.5 94-54c-1-9.9-7.6-20.9-15.5-25.5z"
                    clip-rule="evenodd"
                />
                <path
                    d="M144.2 521.5c-8.7-5-15.8-.4-15.8 10.2V628c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V550c0-10.7-7.1-23.5-15.8-28.5z"
                    class="rain_cloud_st2"
                />
                <path
                    d="M158.5 577.7h3V550c0-8.3-4-17.7-9.8-24.2l-2.3 1.7c0 .1 0 .1-.1.1 5.4 5.9 9.2 14.7 9.2 22.4v27.7zM158.5 597.4V633h3v-35.5l-3-.1z"
                    class="rain_cloud_st3"
                />
                <path
                    d="M218.2 478.5h0c-4.3-2.5-8.1-2.6-11-.9h0L134 520.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st4"
                />
                <path
                    d="M314.2 494.5c-4.3-2.5-8.1-2.6-11-.9L230 536.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st0"
                />
                <linearGradient
                    id="rain_cloud_SVGID_00000019672246493136914530000017691823832758014610_"
                    x1="267.863"
                    x2="283.005"
                    y1="518.402"
                    y2="544.628"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#FFF" />
                    <stop offset="1" stop-color="#BBDEFB" />
                </linearGradient>
                <path
                    fill="url(#rain_cloud_SVGID_00000019672246493136914530000017691823832758014610_)"
                    fill-rule="evenodd"
                    d="M314.2 494.5c-1.1-.7-2.2-1.1-3.3-1.5l-80.4 46.5 5.2 34.5 94-54c-1-9.9-7.6-20.9-15.5-25.5z"
                    clip-rule="evenodd"
                />
                <path
                    d="M240.2 537.5c-8.7-5-15.8-.4-15.8 10.2V644c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V566c0-10.7-7.1-23.5-15.8-28.5z"
                    class="rain_cloud_st2"
                />
                <path
                    d="M244.7 543c5.7 5.9 9.8 15.1 9.8 23v65.5h3V566c0-8.6-4.4-18.5-10.6-25l-2.2 2z"
                    class="rain_cloud_st3"
                />
                <path
                    d="M314.2 494.5h0c-4.3-2.5-8.1-2.6-11-.9h0L230 536.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st4"
                />
                <path
                    d="M407.2 588.5c-4.3-2.5-8.1-2.6-11-.9L323 630.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st0"
                />
                <linearGradient
                    id="rain_cloud_SVGID_00000049942763868431269320000007415542340460020129_"
                    x1="360.896"
                    x2="376.034"
                    y1="612.476"
                    y2="638.696"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#FFF" />
                    <stop offset="1" stop-color="#BBDEFB" />
                </linearGradient>
                <path
                    fill="url(#rain_cloud_SVGID_00000049942763868431269320000007415542340460020129_)"
                    fill-rule="evenodd"
                    d="M407.2 588.5c-1.1-.6-2.2-1.1-3.2-1.5l-80.5 46.6 5.2 34.5 94-54c-.9-9.9-7.5-21-15.5-25.6z"
                    clip-rule="evenodd"
                />
                <path
                    d="M333.2 631.5c-8.7-5-15.8-.4-15.8 10.2V738c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V660c0-10.7-7.1-23.5-15.8-28.5z"
                    class="rain_cloud_st2"
                />
                <path
                    d="M347.5 698.2c.9-.3 1.8-.3 2.7-.1h.3V660c0-8.3-4.1-17.8-9.9-24.3l-1.9 2.4c5.2 5.9 8.8 14.4 8.8 21.9v38.2zM350.5 752.4v-22.7h-1.6l-1.4-.2v23.1c1-.2 2-.2 3-.2z"
                    class="rain_cloud_st3"
                />
                <path
                    d="M407.2 588.5h0c-4.3-2.5-8.1-2.6-11-.9h0L323 630.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st4"
                />
                <path
                    d="M502.2 603.5c-4.3-2.5-8.1-2.6-11-.9L418 645.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st0"
                />
                <linearGradient
                    id="rain_cloud_SVGID_00000077283767240749723500000001028789906870705848_"
                    x1="455.895"
                    x2="471.03"
                    y1="627.475"
                    y2="653.69"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#FFF" />
                    <stop offset="1" stop-color="#BBDEFB" />
                </linearGradient>
                <path
                    fill="url(#rain_cloud_SVGID_00000077283767240749723500000001028789906870705848_)"
                    fill-rule="evenodd"
                    d="M502.2 603.5c-1.1-.6-2.2-1.1-3.2-1.5l-80.5 46.6 5.2 34.5 94-54c-.9-9.9-7.5-21-15.5-25.6z"
                    clip-rule="evenodd"
                />
                <path
                    d="M428.2 646.5c-8.7-5-15.8-.4-15.8 10.2V753c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V675c0-10.7-7.1-23.5-15.8-28.5z"
                    class="rain_cloud_st2"
                />
                <path
                    d="m442.5 736.7 2.6.3h.4v-62.1c0-8.7-4.5-18.7-10.7-25.1-.6.8-1.2 1.6-1.9 2.3 5.6 5.9 9.6 14.9 9.6 22.8v61.8z"
                    class="rain_cloud_st3"
                />
                <path
                    d="M502.2 603.5h0c-4.3-2.5-8.1-2.6-11-.9h0L418 645.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                    class="rain_cloud_st4"
                />
                <path
                    d="M579.5 482.7c0-55.4-34.7-121.8-80.9-159.1 3.2-7.7 5-17.1 5-28 0-47.4-34-105.6-75.8-129.9-15.6-9-30.2-12-42.1-9.8-21.9-55.7-62.8-108.2-109.6-135.3-38.1-22-72.2-22.7-95.3-6l-65.1 37.5 34.6 25.4c-.4 4.4-.6 8.8-.6 13.3 0 2.4.1 4.9.2 7.3-44.3-7.9-76 21.5-76 77.7 0 71.2 50.9 158.5 113.8 194.9l274.8 159.1 17.2 57.2 71.9-41.1c17.3-10.7 27.9-32.4 27.9-63.2z"
                    class="rain_cloud_st9"
                />
                <linearGradient
                    id="rain_cloud_SVGID_00000021077619495736028840000005401599907483081910_"
                    x1="541.632"
                    x2="635.011"
                    y1="502.58"
                    y2="340.842"
                    gradientTransform="matrix(1 0 0 -1 -168.2 667.4)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#FFF" />
                    <stop offset="1" stop-color="#BBDEFB" />
                </linearGradient>
                <path
                    fill="url(#rain_cloud_SVGID_00000021077619495736028840000005401599907483081910_)"
                    fill-rule="evenodd"
                    d="m428.6 363.8 70.1-40.8v-.2c3.2-7.8 5-17.2 5-28 0-47.5-34-105.7-75.8-129.9-15.6-9.1-30.2-12.1-42.1-9.9-.1-.1-.1-.3-.2-.4l-70 40.9 113 168.3z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="rain_cloud_SVGID_00000105425273161635803280000010770631400991986340_"
                    x1="610.316"
                    x2="711.045"
                    y1="308.371"
                    y2="133.903"
                    gradientTransform="matrix(1 0 0 -1 -168.2 667.4)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#FFF" />
                    <stop offset="1" stop-color="#BBDEFB" />
                </linearGradient>
                <path
                    fill="url(#rain_cloud_SVGID_00000105425273161635803280000010770631400991986340_)"
                    fill-rule="evenodd"
                    d="m479.7 586.1 71.9-41.2c17.3-10.6 27.9-32.3 27.9-63 0-55.3-34.6-121.7-80.8-158.9l-94.5 55 51.1 146.7 7.2 4.2 17.2 57.2z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="rain_cloud_SVGID_00000142161532485269102320000003254897682195377822_"
                    x1="365.508"
                    x2="469.083"
                    y1="660.1"
                    y2="480.703"
                    gradientTransform="matrix(1 0 0 -1 -168.2 667.4)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#FFF" />
                    <stop offset="1" stop-color="#BBDEFB" />
                </linearGradient>
                <path
                    fill="url(#rain_cloud_SVGID_00000142161532485269102320000003254897682195377822_)"
                    fill-rule="evenodd"
                    d="M385.6 154.9C363.7 99.1 322.9 46.8 276.1 19.7 238-2.3 203.9-3 180.8 13.6l-65.1 37.5 34.6 25.5c-.4 4.4-.6 8.8-.6 13.2 0 1.5 0 2.9.1 4.4l118.4 126.5 117.4-65.8z"
                    clip-rule="evenodd"
                />
                <path
                    d="M427.8 364.7c3.2-7.7 5-17.1 5-28 0-47.5-34-105.6-75.8-129.9-15.6-9-30.2-12-42.1-9.8C293 141.3 252.1 88.8 205.3 61.7c-69.8-40.5-126.5-9-126.5 70.1 0 2.4.1 5 .2 7.4-44.3-8-76 21.5-76 77.7 0 71.2 50.9 158.5 113.8 194.9l290.8 168.3c55.9 32.4 101.1 7.3 101.1-56-.1-55.7-34.9-122.1-80.9-159.4z"
                    class="rain_cloud_st2"
                />
                <path
                    d="M260.1 107.3c.2-.4.4-.8.6-1.1-17-18.9-35.6-34.7-54.8-45.8C184.3 48 163.6 42 145 42.6c0 1-.1 2-.1 3 18.1-.7 38.3 5.2 59.5 17.5 19 11 37.5 26.7 54.2 45.4.4-.5.9-.9 1.5-1.2zM313.9 198.6h1.2c12.1-2.3 26.3 1.1 41 9.6 9.7 5.8 18.7 12.7 26.6 20.8.5-.9 1.3-1.6 2.3-1.9-8.1-8.3-17.3-15.6-27.3-21.5-14.9-8.6-29.3-12.1-41.9-10.2-5.5-13.8-12-27.2-19.5-40-.6.8-1.5 1.4-2.5 1.6 7.5 13 14.1 26.6 19.7 40.6l.4 1zM498.7 564.5c.6.1 1.1.4 1.6.7.5 0 .9.1 1.3.4 5.6-11.4 8.5-25.5 8.5-41.6 0-54.5-33.8-121.4-80.6-159.6 3.3-8.8 4.9-18.2 4.7-27.6 0-16.9-4.4-35.2-11.6-52.8-.9.5-1.9.7-2.9.7 7.3 17.3 11.5 35.4 11.5 52 0 10.4-1.7 19.7-5 27.5l-.4 1 1 .7c46.6 37.6 80.3 104.1 80.3 158 0 15.8-2.9 29.6-8.4 40.6z"
                    class="rain_cloud_st3"
                />
                <path
                    d="M579.5 482.7c0-55.4-34.7-121.8-80.9-159.1 3.2-7.7 5-17.1 5-28 0-47.4-34-105.6-75.8-129.9-15.6-9-30.2-12-42.1-9.8-21.9-55.7-62.8-108.2-109.6-135.3-38.1-22-72.2-22.7-95.3-6l-64.4 37C93.2 64.2 78.8 92 78.8 131.8c0 2.4.1 5 .2 7.4-44.3-8-76 21.5-76 77.7 0 71.2 50.9 158.5 113.8 194.9l290.8 168.3c31.2 18 59 18.2 77.5 3.9l66.6-38.1c17.2-10.7 27.8-32.4 27.8-63.2z"
                    class="rain_cloud_st13"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enable-background="new 0 0 582.5 786.3"
                viewBox="0 0 582.5 786.3"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <g id="rain_cloud_Dark">
                    <path
                        d="M124.2 385.5c-4.3-2.5-8.1-2.6-11-.9L40 427.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st15"
                    />
                    <linearGradient
                        id="rain_cloud_SVGID_00000123435431457731948660000012461282625786318491_"
                        x1="76.747"
                        x2="91.882"
                        y1="409.416"
                        y2="435.632"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#CED4DB" />
                        <stop offset="1" stop-color="#09264A" />
                    </linearGradient>
                    <path
                        fill="url(#rain_cloud_SVGID_00000123435431457731948660000012461282625786318491_)"
                        fill-rule="evenodd"
                        d="M123.1 385.5c-1.1-.7-2.2-1.1-3.3-1.5l-80.4 46.5 5.2 34.5 94-54c-1-9.9-7.6-20.9-15.5-25.5z"
                        clip-rule="evenodd"
                    />
                    <path
                        d="M50.2 428.5c-8.7-5-15.8-.4-15.8 10.2V535c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V457c0-10.7-7.1-23.5-15.8-28.5z"
                        class="rain_cloud_st17"
                    />
                    <path
                        d="M64.5 497.5h2.2l.8-.5v-40c-.1-4.2-.9-8.4-2.6-12.3l-2.3.8-.5.2c1.5 3.6 2.3 7.4 2.4 11.3v40.5z"
                        class="rain_cloud_st15"
                    />
                    <path
                        d="M124.2 385.5h0c-4.3-2.5-8.1-2.6-11-.9h0L40 427.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st18"
                    />
                    <path
                        d="M218.2 478.5c-4.3-2.5-8.1-2.6-11-.9L134 520.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st15"
                    />
                    <linearGradient
                        id="rain_cloud_SVGID_00000063631731977974341220000004715273161469543317_"
                        x1="170.368"
                        x2="185.504"
                        y1="502.409"
                        y2="528.625"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#CED4DB" />
                        <stop offset="1" stop-color="#09264A" />
                    </linearGradient>
                    <path
                        fill="url(#rain_cloud_SVGID_00000063631731977974341220000004715273161469543317_)"
                        fill-rule="evenodd"
                        d="M216.7 478.5c-1.1-.7-2.2-1.1-3.3-1.5L133 523.6l5.2 34.5 94-54c-1-10-7.6-21-15.5-25.6z"
                        clip-rule="evenodd"
                    />
                    <path
                        d="M144.2 521.5c-8.7-5-15.8-.4-15.8 10.2V628c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V550c0-10.7-7.1-23.5-15.8-28.5z"
                        class="rain_cloud_st17"
                    />
                    <path
                        d="M158.5 577.7h3V550c0-8.3-4-17.7-9.8-24.2l-2.3 1.7c0 .1 0 .1-.1.1 5.4 5.9 9.2 14.7 9.2 22.4v27.7zM158.5 597.4V633h3v-35.5l-3-.1z"
                        class="rain_cloud_st15"
                    />
                    <path
                        d="M218.2 478.5h0c-4.3-2.5-8.1-2.6-11-.9h0L134 520.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st18"
                    />
                    <path
                        d="M314.2 494.5c-4.3-2.5-8.1-2.6-11-.9L230 536.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st15"
                    />
                    <linearGradient
                        id="rain_cloud_SVGID_00000004548029127615887860000009563991138246573446_"
                        x1="266.176"
                        x2="281.318"
                        y1="518.402"
                        y2="544.628"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#CED4DB" />
                        <stop offset="1" stop-color="#09264A" />
                    </linearGradient>
                    <path
                        fill="url(#rain_cloud_SVGID_00000004548029127615887860000009563991138246573446_)"
                        fill-rule="evenodd"
                        d="M312.5 494.5c-1.1-.7-2.2-1.1-3.3-1.5l-80.4 46.5L234 574l94-54c-.9-9.9-7.5-20.9-15.5-25.5z"
                        clip-rule="evenodd"
                    />
                    <path
                        d="M240.2 537.5c-8.7-5-15.8-.4-15.8 10.2V644c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V566c0-10.7-7.1-23.5-15.8-28.5z"
                        class="rain_cloud_st17"
                    />
                    <path
                        d="M244.7 543c5.7 5.9 9.8 15.1 9.8 23v65.5h3V566c0-8.6-4.4-18.5-10.6-25l-2.2 2z"
                        class="rain_cloud_st15"
                    />
                    <path
                        d="M314.2 494.5h0c-4.3-2.5-8.1-2.6-11-.9h0L230 536.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st18"
                    />
                    <path
                        d="M407.2 588.5c-4.3-2.5-8.1-2.6-11-.9L323 630.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st15"
                    />
                    <linearGradient
                        id="rain_cloud_SVGID_00000177480559446408627990000001897480274579469723_"
                        x1="359.583"
                        x2="374.721"
                        y1="612.476"
                        y2="638.696"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#CED4DB" />
                        <stop offset="1" stop-color="#09264A" />
                    </linearGradient>
                    <path
                        fill="url(#rain_cloud_SVGID_00000177480559446408627990000001897480274579469723_)"
                        fill-rule="evenodd"
                        d="M405.9 588.5c-1.1-.6-2.2-1.1-3.2-1.5l-80.5 46.6 5.2 34.5 94-54c-.9-9.9-7.5-21-15.5-25.6z"
                        clip-rule="evenodd"
                    />
                    <path
                        d="M333.2 631.5c-8.7-5-15.8-.4-15.8 10.2V738c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V660c0-10.7-7.1-23.5-15.8-28.5z"
                        class="rain_cloud_st17"
                    />
                    <path
                        d="M347.5 698.2c.9-.3 1.8-.3 2.7-.1h.3V660c0-8.3-4.1-17.8-9.9-24.3l-1.9 2.4c5.2 5.9 8.8 14.4 8.8 21.9v38.2zM350.5 752.4v-22.7h-1.6l-1.4-.2v23.1c1-.2 2-.2 3-.2z"
                        class="rain_cloud_st15"
                    />
                    <path
                        d="M407.2 588.5h0c-4.3-2.5-8.1-2.6-11-.9h0L323 630.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st18"
                    />
                    <path
                        d="M502.2 603.5c-4.3-2.5-8.1-2.6-11-.9L418 645.2c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1l74.3-43.1c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st15"
                    />
                    <linearGradient
                        id="rain_cloud_SVGID_00000121257522559520857810000012364077748566167981_"
                        x1="455.345"
                        x2="470.994"
                        y1="626.522"
                        y2="653.628"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#CED4DB" />
                        <stop offset="1" stop-color="#09264A" />
                    </linearGradient>
                    <path
                        fill="url(#rain_cloud_SVGID_00000121257522559520857810000012364077748566167981_)"
                        fill-rule="evenodd"
                        d="M502.2 603.5c-1.1-.6-3.4-1.7-4.4-2L417.3 648l6.4 35.1 94-54c-.9-9.9-7.5-21-15.5-25.6z"
                        clip-rule="evenodd"
                    />
                    <path
                        d="M428.2 646.5c-8.7-5-15.8-.4-15.8 10.2V753c0 10.6 7.1 23.3 15.8 28.4s15.8.4 15.8-10.1V675c0-10.7-7.1-23.5-15.8-28.5z"
                        class="rain_cloud_st17"
                    />
                    <path
                        d="m442.5 736.7 2.6.3h.4v-62.1c0-8.7-4.5-18.7-10.7-25.1-.6.8-1.2 1.6-1.9 2.3 5.6 5.9 9.6 14.9 9.6 22.8v61.8z"
                        class="rain_cloud_st15"
                    />
                    <path
                        d="M502.2 603.5h0c-4.3-2.5-8.1-2.6-11-.9h0L418 645.2h0c-3.4 1.6-5.6 5.6-5.6 11.4v96.3c0 10.6 7.1 23.3 15.8 28.4 4.1 2.3 7.8 2.6 10.6 1.1h0l74.3-43.1h0c3-1.8 4.9-5.6 4.9-11.1v-96.3c0-10.6-7.1-23.4-15.8-28.4z"
                        class="rain_cloud_st18"
                    />
                    <path
                        d="M579.5 482.7c0-55.4-34.7-121.8-80.9-159.1 3.2-7.7 5-17.1 5-28 0-47.4-34-105.6-75.8-129.9-15.6-9-30.2-12-42.1-9.8-21.9-55.7-62.8-108.2-109.6-135.3-38.1-22-72.2-22.7-95.3-6l-65.1 37.5 34.6 25.4c-.4 4.4-.6 8.8-.6 13.3 0 2.4.1 4.9.2 7.3-44.3-7.9-76 21.5-76 77.7 0 71.2 50.9 158.5 113.8 194.9l274.8 159.1 17.2 57.2 71.9-41.1c17.3-10.7 27.9-32.4 27.9-63.2z"
                        class="rain_cloud_st23"
                    />
                    <linearGradient
                        id="rain_cloud_SVGID_00000079481553214532514810000011851140765102373796_"
                        x1="541.632"
                        x2="635.011"
                        y1="502.58"
                        y2="340.842"
                        gradientTransform="matrix(1 0 0 -1 -168.2 667.4)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#CED4DB" />
                        <stop offset="1" stop-color="#09264A" />
                    </linearGradient>
                    <path
                        fill="url(#rain_cloud_SVGID_00000079481553214532514810000011851140765102373796_)"
                        fill-rule="evenodd"
                        d="m428.6 363.8 70.1-40.8v-.2c3.2-7.8 5-17.2 5-28 0-47.5-34-105.7-75.8-129.9-15.6-9.1-30.2-12.1-42.1-9.9-.1-.1-.1-.3-.2-.4l-70 40.9 113 168.3z"
                        clip-rule="evenodd"
                    />
                    <linearGradient
                        id="rain_cloud_SVGID_00000030470769915358903200000017918106913079565987_"
                        x1="610.316"
                        x2="711.045"
                        y1="308.371"
                        y2="133.903"
                        gradientTransform="matrix(1 0 0 -1 -168.2 667.4)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#CED4DB" />
                        <stop offset="1" stop-color="#09264A" />
                    </linearGradient>
                    <path
                        fill="url(#rain_cloud_SVGID_00000030470769915358903200000017918106913079565987_)"
                        fill-rule="evenodd"
                        d="m479.7 586.1 71.9-41.2c17.3-10.6 27.9-32.3 27.9-63 0-55.3-34.6-121.7-80.8-158.9l-94.5 55 51.1 146.7 7.2 4.2 17.2 57.2z"
                        clip-rule="evenodd"
                    />
                    <linearGradient
                        id="rain_cloud_SVGID_00000134967020458576914260000000237754945220174006_"
                        x1="365.508"
                        x2="469.083"
                        y1="660.1"
                        y2="480.703"
                        gradientTransform="matrix(1 0 0 -1 -168.2 667.4)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#CED4DB" />
                        <stop offset="1" stop-color="#09264A" />
                    </linearGradient>
                    <path
                        fill="url(#rain_cloud_SVGID_00000134967020458576914260000000237754945220174006_)"
                        fill-rule="evenodd"
                        d="M385.6 154.9C363.7 99.1 322.9 46.8 276.1 19.7 238-2.3 203.9-3 180.8 13.6l-65.1 37.5 34.6 25.5c-.4 4.4-.6 8.8-.6 13.2 0 1.5 0 2.9.1 4.4l118.4 126.5 117.4-65.8z"
                        clip-rule="evenodd"
                    />
                    <path
                        d="M427.8 364.7c3.2-7.7 5-17.1 5-28 0-47.5-34-105.6-75.8-129.9-15.6-9-30.2-12-42.1-9.8C293 141.3 252.1 88.8 205.3 61.7c-69.8-40.5-126.5-9-126.5 70.1 0 2.4.1 5 .2 7.4-44.3-8-76 21.5-76 77.7 0 71.2 50.9 158.5 113.8 194.9l290.8 168.3c55.9 32.4 101.1 7.3 101.1-56-.1-55.7-34.9-122.1-80.9-159.4z"
                        class="rain_cloud_st17"
                    />
                    <path
                        d="M260.1 107.3c.2-.4.4-.8.6-1.1-17-18.9-35.6-34.7-54.8-45.8C184.3 48 163.6 42 145 42.6c0 1-.1 2-.1 3 18.1-.7 38.3 5.2 59.5 17.5 19 11 37.5 26.7 54.2 45.4.4-.5.9-.9 1.5-1.2zM313.9 198.6h1.2c12.1-2.3 26.3 1.1 41 9.6 9.7 5.8 18.7 12.7 26.6 20.8.5-.9 1.3-1.6 2.3-1.9-8.1-8.3-17.3-15.6-27.3-21.5-14.9-8.6-29.3-12.1-41.9-10.2-5.5-13.8-12-27.2-19.5-40-.6.8-1.5 1.4-2.5 1.6 7.5 13 14.1 26.6 19.7 40.6l.4 1zM498.7 564.5c.6.1 1.1.4 1.6.7.5 0 .9.1 1.3.4 5.6-11.4 8.5-25.5 8.5-41.6 0-54.5-33.8-121.4-80.6-159.6 3.3-8.8 4.9-18.2 4.7-27.6 0-16.9-4.4-35.2-11.6-52.8-.9.5-1.9.7-2.9.7 7.3 17.3 11.5 35.4 11.5 52 0 10.4-1.7 19.7-5 27.5l-.4 1 1 .7c46.6 37.6 80.3 104.1 80.3 158 0 15.8-2.9 29.6-8.4 40.6z"
                        class="rain_cloud_st15"
                    />
                    <path
                        d="M579.5 482.7c0-55.4-34.7-121.8-80.9-159.1 3.2-7.7 5-17.1 5-28 0-47.4-34-105.6-75.8-129.9-15.6-9-30.2-12-42.1-9.8-21.9-55.7-62.8-108.2-109.6-135.3-38.1-22-72.2-22.7-95.3-6l-64.4 37C93.2 64.2 78.8 92 78.8 131.8c0 2.4.1 5 .2 7.4-44.3-8-76 21.5-76 77.7 0 71.2 50.9 158.5 113.8 194.9l290.8 168.3c31.2 18 59 18.2 77.5 3.9l66.6-38.1c17.2-10.7 27.8-32.4 27.8-63.2z"
                        class="rain_cloud_st27"
                    />
                </g>
            </svg>
        );
    }
}
